import React, { useRef } from "react";
import { useForm } from "react-hook-form";
//material-ui
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
//import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { HookFormContent } from "components";

const useStyles = makeStyles(theme => ({
  title : {
    padding : theme.spacing(2, 0, 0, 2)
  },
  searchContent : {
    padding : theme.spacing(0, 2, 0, 0)
  },
  searchField : {
    padding : theme.spacing(1, 0, 0, 2)
  },
  content: {
    padding: theme.spacing(0, 0, 1)
  },
  searchForm: {
    padding: theme.spacing(2)
  },
  searchFormField: {
    paddingRight: theme.spacing(2)
  },
  buttonActions: {
    margin: theme.spacing(2, 4),
    display: "flex",
    justifyContent: "flex-end"
  },
  button: {
    margin: theme.spacing(0, 0, 0, 2)
  }
}));

export default function ShareSearch(props) {
  const classes = useStyles();
  const buttonRef = useRef();
  const formContext = useForm({
    mode: "onBlur"
  });
  const { handleSubmit, reset } = formContext;
  const { formSchema, onSearch, formTitle } = props;
  const defaultValue = {};
  formSchema.forEach(item => {
    const { type, name } = item;
    defaultValue[name] = type === "time" ? null : "";
  });
  const handleReset = () => {
    reset(defaultValue);
    buttonRef.current && buttonRef.current.click()
  };
  const breakpoints = { lg: 2, xl: 2, xs: 12, sm: 6, md: 4 };

  return (
    <div className={classes.content}>
      <Paper elevation={2}>
        <Grid container>
          <form onSubmit={handleSubmit(onSearch)} style={{ width: "100%" }}>
            <Grid item lg={12}>
              {formTitle && <div className={classes.title}>
                <Typography variant="h6">
                  {formTitle}
                </Typography>
              </div>}
              <div className={classes.searchContent}>
                <Grid container>
                  {formSchema.map((schema, index) => {
                    return (<Grid item key={index} {...breakpoints}>
                      <div className={classes.searchField}>
                        <HookFormContent schema={schema} formContext={formContext} />
                      </div>
                    </Grid>);
                  })}
                </Grid>
              </div>
            </Grid>
            <Grid item lg={12}>
              <div className={classes.buttonActions}>
                <Button variant="contained" className={classes.button} size="small" onClick={handleReset}>
                  重置
                </Button>
                <Button color="primary" variant="contained" size="small" type="submit" className={classes.button} ref={buttonRef}>
                  查询
                </Button>
              </div>
            </Grid>
          </form>
        </Grid>
      </Paper>
    </div>
  );
}
